<template>
  <div>
    <modal-cadu
        close
        :width="380"
        v-model="show"
    >
        <div slot="all" class="pt-10 pb-4 px-10">
            <div slot="header">
                <div class="font-secundaria headline font-weight-bold pb-4" style="color: #00995D">
                    NOVA UNIMED
                </div>
            </div>
            <div slot="body">
              <v-row>
                <v-col cols="12" class="py-0">
                  Digite o código para procurar a unimed.
                </v-col>
                <v-col cols="12" sm="7" class="pb-0 pr-2">
                    <ValidationProvider mode="eager" ref="codigo" rules="max:4|required" v-slot:default="{ errors }">
                        <input-cadu
                          :errorMessage="errors[0]"
                          @enter="loadSearchCodigo"
                          @tab="loadSearchCodigo"
                          title="Código"
                          :max="'4'"
                          onlyNumber
                          v-model="cdUnimed"
                          :colorText="$vuetify.theme.themes.light.fontColor1"
                        />
                    </ValidationProvider>
                </v-col>
                <v-col cols="auto" class="pt-9 pl-0">
                  <button-search @click="loadSearchCodigo"/>
                </v-col>
              </v-row>
            </div>
            <div slot="footer" class="pt-6">
                <v-row justify="end">
                    <v-col cols="auto">
                        <button-cadu :disabled="!unimedValida" @click="avancarNovaUnimed">
                            AVANÇAR
                        </button-cadu>
                    </v-col>
                </v-row>
            </div>
        </div>
    </modal-cadu>
    <overlay-loading :value="isLoadingOverlay" />
    <ModalCodigo
      v-model="showModalCodigo"
      :titulo="tituloCodigo"
      :descricao="descricaoCodigo"
    />
    <error-modal
      v-model="error"
      :errObj="errObj"
    />
  </div>
</template>

<script>
import Unimed from '@/services/Unimed'
import { ValidationProvider } from 'vee-validate'
import ModalCodigo from './ModalCodigo'

export default {
  props: {
    value: {
      type: Boolean,
      default: false
    }
  },
  components: {
    ValidationProvider,
    ModalCodigo
  },
  data () {
    return {
      show: this.value,
      unimedValida: false,
      isLoadingOverlay: false,
      tokenBearer: localStorage.getItem('tokenBearer'),
      showModalCodigo: false,
      tituloCodigo: '',
      descricaoCodigo: '',
      cdUnimed: '',
      codigoValido: '',
      error: false,
      errObj: {}
    }
  },
  methods: {
    async avancarNovaUnimed () {
      this.isLoadingOverlay = true
      const unimed = new Unimed(this.tokenBearer, this.$appConfig.config.API)

      try {
        const res = await unimed.novaUnimed(this.cdUnimed)
        this.isLoadingOverlay = false
        localStorage.setItem('idUnimed', res.data)
        this.$router.push({ name: 'novaUnimed' })
      } catch (err) {
        this.isLoadingOverlay = false
        this.error = true
        this.errObj.status = err.response.status
        this.errObj.error = err.response.data.message
        console.error(err)
      }
    },
    async loadSearchCodigo () {
      let res = await this.$refs.codigo.validate()
      if (res.valid) {
        this.isLoadingOverlay = true
        await this.searchCodigo()
        this.isLoadingOverlay = false
      }
    },
    async searchCodigo () {
      let unimed = new Unimed(this.tokenBearer, this.$appConfig.config.API)
      try {
        let response = await unimed.verifyCodigo(this.cdUnimed)
        response = response.data
        this.unimedValida = true
        this.codigoValido = this.cdUnimed
        if (response) {
          this.codigoValido = ''
          this.tituloCodigo = response.titulo
          this.descricaoCodigo = response.descricao
          this.unimedValida = false
          this.showModalCodigo = true
        }
      } catch (err) {
        this.error = true
        this.errObj.status = err.response.status
        this.errObj.error = err.response.data.message
        console.error(err)
      }
    }
  },
  watch: {
    value () {
      this.show = this.value
      if (!this.show) {
        this.cdUnimed = ''
      }
    },
    show () {
      this.$emit('input', this.show)
    },
    cdUnimed () {
      if (this.unimedValida && this.cdUnimed !== this.codigoValido) {
        this.unimedValida = false
      }
    }
  }
}
</script>

<style>

</style>
